import { z } from 'zod';
/** Neither id is required: asking with neither returns nothing rather than everything. */
export const PracticePreferenceFindAllByEntityQuerySchema = z
    .object({
    practiceGroupId: z.uuid().optional(),
    organizationId: z.uuid().optional(),
})
    .strict();
//# sourceMappingURL=findAllByEntity.js.map